export const DataShare = {
  Button: {
    EKusuriLink: {
      Create: 'e薬Linkワンタイムコードを発行する',
      Recreate: 'e薬Linkワンタイムコードを再発行する',
    },
    SharedThirdParty: {
      Share: '共有する',
      AgreeTerm: '利用規約に同意して利用する',
      OnetimeCodeCreate: 'ワンタイムコード再発行',
    },
    MedicineList: {
      Prescription: '処方薬',
      OverTheCounter: '市販薬',
      Display: '表示',
    },
    JahisExport: {
      Export: '出力する',
      Ok: 'OK',
    },
  },
  PageName: {
    Share: 'お薬手帳の共有',
    EKusuriLink: {
      Share: '薬局に共有',
      OnetimeCode: 'e薬Linkワンタイムコード発行',
    },
    SharedThirdParty: '病院や家族に共有',
    MedicineList: '',
    ImageView: '画像表示',
    JahisExport: '処方薬データの出力',
  },
  Label: {
    Share: {
      MedicineShare: '病院や家族に共有',
      EKusuriLink: '薬局に共有',
    },
    EKusuriLink: {
      Share: {
        Explanation:
          'e薬Linkワンタイムコードを発行して\nお薬手帳の情報を薬局に共有します。',
        Target: '共有するお薬手帳',
      },
      OnetimeCode: {
        Explanation:
          'e薬Linkワンタイムコードを発行しました。\n薬局の方に提示してください。',
        Target: '共有するお薬手帳',
        OnetimeCode: 'e薬Linkワンタイムコード',
        Limit: 'まで有効',
      },
    },
    SharedThirdParty: {
      HowTo: '利用方法',
      HowToText1:
        '1. お薬手帳を共有したい病院や家族にタヨリス共有サービス {0} にアクセスしてもらいます。',
      HowToText2:
        '2. タヨリス共有サービスに表示されたワンタイムコードをアプリの本画面下部「ワンタイムコード」欄に入力し、「共有する」をタップしてください。',
      HowToText3:
        '3. 病院や家族がアクセスしたタヨリス共有サービス上にお薬手帳の情報が表示されます。',
      CustomerNumber: 'お客様番号',
      Target: '共有するお薬手帳',
      OnetimeCode: 'ワンタイムコード：',
      Validation: {
        invalidInput: '無効な入力値です。',
        invalidLength: '1~5桁で入力してください。',
      },
      Viewer: {
        TopText1: 'このサイトはタヨリスのお薬手帳を表示するために利用します。',
        TopText2:
          '次の画面で表示されたワンタイムコードをタヨリスアプリで入力してください。',
        OnetimeCode:
          '表示されたワンタイムコードを参照したいお薬手帳をお持ちの利用者へお伝え下さい。',
        Expired: '有効期限：',
      },
    },
    MedicineList: {
      MedicineList: 'お薬手帳',
      ExpiresIn: '表示有効期限：',
      CustomerId: 'お客様番号',
      Minutes: '分',
      Seconds: '秒',
      SpecialNotes: {
        SpecialNote: '手帳特記事項',
        Allergy: 'アレルギー歴',
        SideEffect: '副作用歴等',
        Sickness: '既往歴等',
      },
      DispensingDate: '調剤日',
      RegistrationDate: '登録日',
      Prescription: '調剤明細書',
      OverTheCounter: '市販薬',
      Memo: '【服薬メモ】',
      PharmacyPostscript: '【薬局追記メモ】',
      TakingStartDate: '服薬開始日',
      TakingEndDate: '服薬終了日',
      CurrentNumber: '件',
      TotalNumber: '件中',
    },
    JahisExport: {
      Share: {
        Introduction: '過去1年分の処方薬データを出力します。',
        CompatibilityNotice: '※取込先アプリの仕様や制限によっては、本アプリから出力したデータが正しく取り込まれない場合があります。あらかじめご了承ください。',
        TargetMedicines: '※処方薬の「写真を登録する」および市販薬（一般用医薬品）のデータは出力されませんのでご注意ください。',
        Target: '出力するお薬手帳',
      },
    },
  },
  DataFormat: {
    YYYYMMDD: 'YYYY/MM/DD',
  },
  Message: {
    SharedThirdParty: {
      Result: {
        Success: 'お薬手帳の共有に成功しました。',
        ExpiredError:
          'お薬手帳の共有に失敗しました。\r\n以下の原因が考えられますので、ご確認の上再度実施してください。\r\n・入力したワンタイムコードが間違っている\r\n・入力したワンタイムコードの有効期限が切れている',
        UnmatchError:
          'お薬手帳の共有に失敗しました。\r\n以下の原因が考えられますので、ご確認の上再度実施してください。\r\n・入力したワンタイムコードが間違っている\r\n・入力したワンタイムコードの有効期限が切れている',
        NotFoundError:
          'お薬手帳の共有に失敗しました。\r\n以下の原因が考えられますので、ご確認の上再度実施してください。\r\n・入力したワンタイムコードが間違っている\r\n・入力したワンタイムコードの有効期限が切れている',
      },
      Alert: {
        InvalidCookie1: 'cookieが無効になっています。',
        InvalidCookie2:
          'この機能を使用するにはCookieを有効にする必要があります。',
      },
    },
    MedicineList: {
      NoPrescription: '処方薬はありません。',
      NoOverTheCounter: '市販薬はありません。',
      NoPictureItem: '写真はありません。',
      Expired: '表示有効期限を超過しました。',
    },
    JahisExport: {
      NoMedicines: 'データがありません。',
      InvalidApiResponse: 'データが不正です。',
    },
  },
};
